import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "govuk-tabs",
  "data-module": "govuk-tabs"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-tabs__title" }, " Contents ", -1)
const _hoisted_3 = ["role"]
const _hoisted_4 = ["role"]
const _hoisted_5 = ["id", "role", "aria-controls", "aria-selected", "tabindex", "onClick"]
const _hoisted_6 = ["id", "role", "aria-labelledby"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", {
      class: "govuk-tabs__list",
      role: _ctx.tabListRole
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(_ctx.tabListItemClassList(index)),
          role: _ctx.tabListItemsRole
        }, [
          _createElementVNode("a", {
            class: "govuk-tabs__tab",
            href: "#active-orders",
            id: _ctx.getTabId(tab),
            role: _ctx.tabRole,
            "aria-controls": _ctx.getAriaControls(tab),
            "aria-selected": _ctx.getAriaSelected(index),
            tabindex: _ctx.getTabIndex(index),
            onClick: _withModifiers(($event: any) => (_ctx.onTabClick(index)), ["prevent"]),
            onKeydown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args)), ["prevent"]))
          }, _toDisplayString(tab.label), 41, _hoisted_5)
        ], 10, _hoisted_4))
      }), 128))
    ], 8, _hoisted_3),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(_ctx.panelClassList(index)),
        id: tab.id,
        role: _ctx.panelRole,
        "aria-labelledby": _ctx.getTabId(tab)
      }, [
        _renderSlot(_ctx.$slots, tab.id)
      ], 10, _hoisted_6))
    }), 128))
  ]))
}